import { PhoneCodes, type PhoneCode } from '@/constants/phone-codes'

/**
 * Находит PhoneCode по ISO коду страны
 * @param isoCode - ISO 3166-1 alpha-2 код страны (например, 'UA', 'US', 'GB')
 * @returns PhoneCode или null если не найдено
 */
export function findPhoneCodeByIsoCode(isoCode: string | null): PhoneCode | null {
  if (!isoCode || isoCode.length !== 2) {
    return null
  }

  return PhoneCodes.find((code) => code.isoCode === isoCode.toUpperCase()) ?? null
}

/**
 * Находит PhoneCode по ISO коду страны с fallback на код по умолчанию
 * @param isoCode - ISO 3166-1 alpha-2 код страны
 * @param defaultCode - Код телефона по умолчанию (по умолчанию '380' - Украина)
 * @returns PhoneCode (всегда возвращает валидный PhoneCode)
 */
export function findPhoneCodeByIsoCodeWithDefault(
  isoCode: string | null,
  defaultCode: string = '380'
): PhoneCode {
  const found = findPhoneCodeByIsoCode(isoCode)
  if (found) {
    return found
  }

  return PhoneCodes.find((code) => code.phoneCode === defaultCode) 
    ?? PhoneCodes.find((code) => code.phoneCode === '380')!
}
